module.exports = __webpack_public_path__ + "static/assets/a5d81f0bb5957ab948236c3b55765c0c.svg";